import React, { useState, useEffect } from 'react';
import DataTableStructure from './DataTableStructure';
import { CURRENCY_SYMBOLS_TEXT } from '../utils/currencySymbols';

const CategorySummaryTables = ({ categoryData, title, defaultCollapsed = false }) => {
  const [collapsedTables, setCollapsedTables] = useState({});

  useEffect(() => {
    const initial = {};
    Object.keys(categoryData).forEach(currency => {
      initial[currency] = defaultCollapsed;
    });
    setCollapsedTables(initial);
  }, [categoryData, defaultCollapsed]);

  const categoryColumns = [
    {
      Header: 'Category',
      accessor: 'category',
    },
    {
      Header: 'Total Amount',
      accessor: 'amount',
    },
    {
      Header: 'Transactions',
      accessor: 'transactions',
    },
  ];

  return (
    <div>
      {Object.entries(categoryData)
        .sort(([, categoriesA], [, categoriesB]) => categoriesB.length - categoriesA.length) // Sort by number of categories
        .map(([currency, data]) => (
          <div key={currency} className="mt-6 border rounded-lg bg-gray-50">
            <button
              onClick={() => setCollapsedTables(prev => ({
                ...prev,
                [currency]: !prev[currency]
              }))}
              className="w-full p-4 flex justify-between items-center text-left"
            >
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  {title ? `${title} - ${CURRENCY_SYMBOLS_TEXT[currency]}` : `Expenses by Category - ${CURRENCY_SYMBOLS_TEXT[currency]}`}
                </h3>
                {data.length > 0 && (
                  <p className="text-sm text-gray-600 mt-1">
                    {data.length} categories
                  </p>
                )}
              </div>
              <svg
                className={`w-6 h-6 transform transition-transform duration-300 ${
                  collapsedTables[currency] ? '' : 'rotate-180'
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            <div 
              className={`transition-all duration-300 ease-in-out ${
                collapsedTables[currency] ? 'overflow-hidden max-h-0 opacity-0' : 'overflow-y-auto max-h-[900px] opacity-100'
              }`}
            >
              <div className="p-4 pt-0">
                <div className="bg-white dark:bg-gray-700">
                  <DataTableStructure
                    columns={categoryColumns}
                    data={data}
                    initialPageSize={5}
                    initialSortBy={[{ id: 'amount', desc: true }]}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default CategorySummaryTables;
